import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';

import { P1R, Table } from 'src/components';
import { themeColors } from 'src/theme';
import { formatPhone } from 'src/utils';
import { TenantType } from 'src/types';

import { TableProps } from '../Table';

export const compnaiesColumnVisibilityModel = {
  title: false,
  phone: false,
  superAdmin: false,
};

type Props = {
  companies: TenantType[];
  isEditable?: boolean;
  hiddenColumns?: { [key: string]: boolean };
} & Partial<TableProps>;

const TenantsTable = ({ companies, isEditable = false, hiddenColumns = {}, ...props }: Props) => {
  const { t } = useTranslation();
  const [columnsVisible, setColumnsVisible] = useState<{ [key: string]: boolean }>({});

  const columns: GridColDef[] = [
    {
      field: 'title',
      headerName: t('companyDashboardPage.companyName'),
      editable: isEditable,
      renderCell: (params: GridRenderCellParams) => <P1R sx={{ cursor: 'pointer', color: themeColors.blue }}>{params.row.title}</P1R>,
      flex: 1,
    },
    {
      field: 'phone',
      headerName: t('companyDashboardPage.phoneNumber'),
      editable: isEditable,
      flex: 1,
      renderCell: (params: GridRenderCellParams) => formatPhone(params.row.phone),
    },
    {
      field: 'website',
      headerName: t('companyDashboardPage.companyUrl'),
      editable: isEditable,
      flex: 1,
    },
  ];

  const getRowHeight = useCallback(() => (columnsVisible?.userRoles ? 'auto' : null), [columnsVisible?.userRoles]);
  const columnsToDisplay = columns.filter((col) => !hiddenColumns[col.field]);

  return (
    <Table
      {...props}
      type="advanced"
      columns={columnsToDisplay}
      rows={companies}
      getRowId={(row) => row.id}
      disableRowSelectionOnClick
      onStateChange={({ columns }) => {
        setColumnsVisible(columns.columnVisibilityModel);
      }}
      getRowHeight={getRowHeight}
    />
  );
};

export default TenantsTable;
